export default __webpack_public_path__ + "static/media/search.d0e0b0cb.svg";